import { createI18n } from 'vue-i18n'
import cs from './locales/cs'
import de from './locales/de'
import en from './locales/en'

export type SupportedLocale = 'cs' | 'de' | 'en'

const savedLocale = localStorage.getItem('locale') as SupportedLocale | null

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale || 'cs',
  fallbackLocale: 'en',
  messages: {
    cs,
    de,
    en
  }
})

export function setLocale(locale: SupportedLocale) {
  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
  document.documentElement.lang = locale
}

export function getLocale(): SupportedLocale {
  return i18n.global.locale.value as SupportedLocale
}
